// Localized field selection for records stored as name_fr / name_en / name_es,
// value_fr / ... — a pure function (no React), usable in class components and utils.
//
// Every language falls back to the other two, so a record written in only ONE language is
// still shown in all three locales. English is the reference language: it comes second
// for fr and es readers, and first for an en reader.
// Falling back to the bare `obj[field]` covers legacy documents with no localized columns.
const CHAINS = {
  en: ["_en", "_fr", "_es"],
  fr: ["_fr", "_en", "_es"],
  es: ["_es", "_en", "_fr"],
};

export function pickLocalized(obj, field, lang) {
  if (!obj) return "";
  const chain = CHAINS[lang] || CHAINS.en;
  for (const suffix of chain) {
    const v = obj[`${field}${suffix}`];
    if (v) return v;
  }
  return obj[field] || "";
}
